const criteria = [
  {
    icon: 'ri-time-line',
    title: '発行スピード',
    description: '最短10秒〜即日など、カードによって発行スピードが異なります。本当に今日中に必要なら「最短10秒」のカードを選びましょう。',
    points: [
      '最短10秒：三井住友カード（NL）、地方銀行系スピード発行カード',
      '最短即日：大手ECモール系カード、リクルートカード',
      '数営業日：JAカード'
    ]
  },
  {
    icon: 'ri-percent-line',
    title: 'ポイント還元率',
    description: '日常的に使うなら還元率の高さも重要です。基本還元率1.0%以上のカードがおすすめです。',
    points: [
      '1.2%：リクルートカード（業界最高水準）',
      '1.0%：大手ECモール系カード',
      '0.5%〜7%：三井住友カード（NL）※対象店舗で高還元'
    ]
  },
  {
    icon: 'ri-money-yen-circle-line',
    title: '年会費',
    description: '初めてのカードなら年会費無料がおすすめ。維持費がかからないので気軽に持てます。',
    points: [
      '永年無料：三井住友カード（NL）、大手ECモール系カード、リクルートカード',
      '初年度無料：地方銀行系スピード発行カード、JAカード',
      '条件付き無料：年1回以上の利用で翌年も無料など'
    ]
  },
  {
    icon: 'ri-store-line',
    title: '特典・優待',
    description: 'よく使うお店やサービスで特典があるカードを選ぶとお得です。',
    points: [
      'コンビニ・飲食店：三井住友カード（NL）で最大7%還元',
      'ECモール：大手ECモール系カードで最大3倍',
      'じゃらん・ホットペッパー：リクルートカードで最大4.2%還元'
    ]
  },
  {
    icon: 'ri-smartphone-line',
    title: 'スマホ決済対応',
    description: 'Apple PayやGoogle Payに対応しているか確認しましょう。即日発行カードは基本的に対応しています。',
    points: [
      'Apple Pay対応：ほぼすべてのカードが対応',
      'Google Pay対応：ほぼすべてのカードが対応',
      'タッチ決済：Visaタッチ、Mastercardコンタクトレス対応'
    ]
  },
  {
    icon: 'ri-shield-check-line',
    title: '付帯保険',
    description: '海外旅行保険やショッピング保険が付帯していると安心です。',
    points: [
      'スマホ保険：地方銀行系スピード発行カード（年間最高3万円）',
      '海外旅行保険：カードによって付帯条件が異なる',
      'ショッピング保険：購入した商品の破損・盗難を補償'
    ]
  }
];

export default function HowToChoose() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">即日発行できるカードの選び方</h2>
        
        <div className="space-y-8">
          {criteria.map((criterion, index) => (
            <div key={index} className="bg-gray-50 p-8 rounded-xl border-2 border-gray-200 hover:border-teal-600 transition-all duration-300">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className={`${criterion.icon} text-teal-600 text-3xl`}></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{criterion.title}</h3>
                  <p className="text-gray-700 leading-relaxed">{criterion.description}</p>
                </div>
              </div>
              
              <div className="ml-18 bg-white p-4 rounded-lg">
                <ul className="space-y-2">
                  {criterion.points.map((point, idx) => (
                    <li key={idx} className="flex items-start gap-2 text-sm text-gray-700">
                      <i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-br from-teal-50 to-teal-100 border-2 border-teal-600 p-8 rounded-xl">
          <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2">
            <i className="ri-user-line text-teal-600"></i>
            利用シーン別おすすめカード
          </h3>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-white p-6 rounded-lg">
              <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                <i className="ri-shopping-bag-line text-teal-600"></i>
                コンビニ・飲食店をよく使う
              </h4>
              <p className="text-sm text-gray-700 mb-2">→ <strong>三井住友カード（NL）</strong></p>
              <p className="text-xs text-gray-600">セブン-イレブン、ローソン、マクドナルドなどで最大7%還元</p>
            </div>

            <div className="bg-white p-6 rounded-lg">
              <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                <i className="ri-shopping-cart-line text-teal-600"></i>
                ECモールでよく買い物する
              </h4>
              <p className="text-sm text-gray-700 mb-2">→ <strong>大手ECモール系カード</strong></p>
              <p className="text-xs text-gray-600">ECモールでポイント最大3倍、基本還元率1.0%</p>
            </div>

            <div className="bg-white p-6 rounded-lg">
              <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                <i className="ri-percent-line text-teal-600"></i>
                とにかく還元率重視
              </h4>
              <p className="text-sm text-gray-700 mb-2">→ <strong>リクルートカード</strong></p>
              <p className="text-xs text-gray-600">基本還元率1.2%と業界最高水準</p>
            </div>

            <div className="bg-white p-6 rounded-lg">
              <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                <i className="ri-smartphone-line text-teal-600"></i>
                スマホ保険が欲しい
              </h4>
              <p className="text-sm text-gray-700 mb-2">→ <strong>地方銀行系スピード発行カード</strong></p>
              <p className="text-xs text-gray-600">スマートフォン保険付帯（年間最高3万円）</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
